export default __webpack_public_path__ + "static/media/NotoSans-Light.ec4d9e92.ttf";